import bugsnag from '@bugsnag/js'
import bugsnagReact from '@bugsnag/plugin-react'
import React from 'react'


const bugsnagClient = bugsnag('273851d06a2816a35cb1dd9017fdcd93')
bugsnagClient.use(bugsnagReact, React)

export default bugsnagClient
